(function Module() {
	'use strict';

	mySynch.controller('BenchmarkDashboardController', [
		'$scope',
		'$q',
		'MySynchFactory',
		'BenchmarkingReportService',
		'mySynchConstantService',
		'performanceMetricsService',
		'performanceContextService',
		'clientLoggerService',
		function BenchmarkDashboardController($s,$q, MSF, benchmarkingService,mySynchConstSvc, perfMetricSvc, perfContextSvc, log) {
			var self				= this;
			self.loading			= true;
			self.showErrorMessage	= false;
			self.errorMessage		= '';
			
			self.dataUpdatedDisplay = null;
			self.dataIsRecent		= true;
			self.thisFarm			= null;
			self.benchmarks			= null;
			self.dataDiff			= null;
			self.tableRows			= null;
			self.territoryManager	= {};
			
			self.currentHerd = MSF.getActiveHerd();
			self.performanceContext = null;
			
			self.codeFile = [];
			
		
			self.regionOptions = [];
			self.herdSizeOptions = [];
			self.farmTypeOptions = [];
			self.breedNameOptions = [];
			self.lactationOptions = [];
			self.vwpRangeOptions = [];
			

			self.defaultRegion = {};
			self.defaultHerdSize = {};
			self.defaultFarmType = {};
			self.defaultBreedName = {};
			self.defaultLactation = {};
			self.defaultVWPRange = {};

				
			self.selectedRegion =    {};
			self.selectedHerdSize =  {};
			self.selectedFarmType = {};
			self.selectedBreedName = {};
			self.selectedLactation = {};
			self.selectedVWPRange = {};

			self.benchmarkShinyUrl = mySynchConstSvc.specialReportsShinyURLPrefix + 'MySYNCH_Benchmarks';

			// deregister functions
			var deregOnHerdChanged = null;
			

			function localizeDate(dateString) {
				var d = moment(dateString);

				return d.subtract(d.utcOffset(), 'minutes');
			}

			function formattedDisplayDate(dateString) {
				var localDate = localizeDate(dateString);

				return localDate.format(MSF.i18n.format.dateLong);
			}

			function dateIsWithinLast30Days(dateString) {
				return dateString && Math.abs(moment(dateString).diff(moment(), 'days')) <= 30;
			}

			function formattedDecimal(val) {
				return (!_.isNumber(val) || _.isNaN(val)) ? val : _.round(val, 1);
			}

			function formattedRate(rate) {
				return _.isNumber(rate) ? _.round(rate * 100, 1) + '%' : rate;
			}

			function formattedRateDiff(diff) {
				if (!_.isNumber(diff)) {
					return 'Not Avalable';
				}

				return diff > 0 ? '+' + diff + '%' : diff + '%';
			}

			function formattedDecimalDiff(diff) {
				if (!_.isNumber(diff)) {
					return 'Not Avalable';
				}

				return diff > 0 ? '+' + diff : diff;
			}

			function diffHighlight(diff) {
				if (diff === 0) {
					return '';
				}

				return diff > 0 ? 'positive-diff' : 'negative-diff';
			}

			function diffDecimals(benchmark, farm) {
				var roundBenchmark	= _.round(benchmark, 1);
				var roundFarm		= _.round(farm, 1);
				var returnVal		= _.round(roundFarm - roundBenchmark, 1);

				return returnVal;
			}

			function diffRates(benchmark, farm) {
				var benchmarkRate	= benchmark * 100;
				var farmRate		= farm		* 100;

				var unroundedRateDiff	= farmRate - benchmarkRate;
				var roundedDiff			= _.round(unroundedRateDiff, 1);

				return roundedDiff;
			}

			function calculateDiffs(benchmark, thisFarms) {
				return {
					avgPregnancyRate:					diffRates(benchmark.avgPregnancyRate,					thisFarms.avgPregnancyRate),
					avgConceptionRate:					diffRates(benchmark.avgConceptionRate,					thisFarms.avgConceptionRate),
					avgInseminationRate:				diffRates(benchmark.avgInseminationRate,				thisFarms.avgInseminationRate),
					avgFirstServiceConceptionRate:		diffRates(benchmark.avgFirstServiceConceptionRate,		thisFarms.avgFirstServiceConceptionRate),
					avgPercentPregnantBy125DaysInMilk:  diffRates(benchmark.avgPercentPregnantBy125DaysInMilk,	thisFarms.avgPercentPregnantBy125DaysInMilk),
					avgPercentPregnantBy150DaysInMilk:  diffRates(benchmark.avgPercentPregnantBy150DaysInMilk,	thisFarms.avgPercentPregnantBy150DaysInMilk),
					avgAverageDaysToFirstService:		diffDecimals(benchmark.avgAverageDaysToFirstService,	thisFarms.avgAverageDaysToFirstService),
					avgAverageServicesPerConception:	diffDecimals(benchmark.avgAverageServicesPerConception, thisFarms.avgAverageServicesPerConception)
				};
			}

			function calcTableRowDisplayRate(labelText, benchmark, farm, unformattedDiff) {
				return {
					label:		labelText,
					benchmark:	formattedRate(benchmark),
					farm:		formattedRate(farm),
					diff:		formattedRateDiff(unformattedDiff),
					diffClass:	diffHighlight(unformattedDiff)
				};
			}

			function calcTableRowDisplayDecimal(labelText, benchmark, farm, unformattedDiff) {
				return {
					label:		labelText,
					benchmark:	formattedDecimal(benchmark),
					farm:		formattedDecimal(farm),
					diff:		formattedDecimalDiff(unformattedDiff),
					diffClass:	''
				};
			}

			// function that returns the name field of a reportLineItem list from MSF.lists from a reportLineItemId, but returns a passed in default value if the reportLineItem is not found
			function getReportLineItemName(reportLineItemId) {
				// we set a default value of "[report line item not found]" so that if the reportLineItem is not found the issue is obvious in the UI and not hidden
				const reportLineItemNotFound = "[report line item not found]";
				var reportLineItemName = reportLineItemNotFound;
				var reportLineItem = _.find(MSF.lists.reportLineItem, {reportLineItemId: reportLineItemId});
				if(!_.isUndefined(reportLineItem)) {
					reportLineItemName = _.get(reportLineItem, 'name',reportLineItemNotFound);
				}
				return reportLineItemName;
			}


			function tableDisplayDataRows(benchmarks, thisFarms, diffs) {
				const conceptionRiskAt1stServiceReportLineItemId = 13;
				const pregnantBy125DIMReportLineItemId = 20;
				const pregnantBy150DIMReportLineItemId = 21;
				const avgDaysToFirstServiceReportLineItemId = 22;
				const avgNumServicesPerConceptionReportLineItemId = 24;
				return [
					calcTableRowDisplayRate('Pregnancy Risk (12-mo. RHA)',		benchmarks.avgPregnancyRate,					thisFarms.avgPregnancyRate,						diffs.avgPregnancyRate),
					calcTableRowDisplayRate('Conception Risk (12-mo. RHA)',		benchmarks.avgConceptionRate,					thisFarms.avgConceptionRate,					diffs.avgConceptionRate),
					calcTableRowDisplayRate('Insemination Risk (12-mo. RHA)',	benchmarks.avgInseminationRate,					thisFarms.avgInseminationRate,					diffs.avgInseminationRate),
					calcTableRowDisplayRate(getReportLineItemName(conceptionRiskAt1stServiceReportLineItemId),	benchmarks.avgFirstServiceConceptionRate,		thisFarms.avgFirstServiceConceptionRate,		diffs.avgFirstServiceConceptionRate),
					calcTableRowDisplayRate(getReportLineItemName(pregnantBy125DIMReportLineItemId),				benchmarks.avgPercentPregnantBy125DaysInMilk,	thisFarms.avgPercentPregnantBy125DaysInMilk,	diffs.avgPercentPregnantBy125DaysInMilk),
					calcTableRowDisplayRate(getReportLineItemName(pregnantBy150DIMReportLineItemId),				benchmarks.avgPercentPregnantBy150DaysInMilk,	thisFarms.avgPercentPregnantBy150DaysInMilk,	diffs.avgPercentPregnantBy150DaysInMilk),
					calcTableRowDisplayDecimal(getReportLineItemName(avgDaysToFirstServiceReportLineItemId),		benchmarks.avgAverageDaysToFirstService,		thisFarms.avgAverageDaysToFirstService,			diffs.avgAverageDaysToFirstService),
					calcTableRowDisplayDecimal(getReportLineItemName(avgNumServicesPerConceptionReportLineItemId),	benchmarks.avgAverageServicesPerConception,		thisFarms.avgAverageServicesPerConception,		diffs.avgAverageServicesPerConception)
				];
			}

			

			// function that returns the value of the displayed total number of cows
			$s.getTotalCowsDisplay = function getTotalCowsDisplay(){
                // first we assume the total cows is based on all herds
				var totalCows = _.get(self.benchmarks,'totalHerdCount',0);
				
				// if the lactation filter is not set to all lactations then we need to determin which lactation head count we need to use 
				if(!_.isEqual(self.selectedLactation,'ALL')){
					 
					var lactationDetails  =  JSON.parse(_.get(self.selectedLactation,'DetailsJson','{}'));
					var totalLactationHeadCountField = _.get(lactationDetails,'[0].totalCowsDisplayField');

					if(!_.isUndefined(totalLactationHeadCountField)){
						totalCows = _.get(self.benchmarks,totalLactationHeadCountField,totalCows);
					}			
					
				}
				return totalCows;
			}
			 
			$s.loadFilterOptions = function loadFilterOptions(){

				var filterOptionsPromise = $q.defer();
				
				perfMetricSvc.startTiming('Page:BenchmarkingFilterOptionsData:Request');
				benchmarkingService.getBenchmarkingReportFilterOptionsData(self.performanceContext,function gotBenchmarkingReportFilterOptionsData(err,results){
					perfMetricSvc.endTiming("page",'Page:BenchmarkingFilterOptionsData:Request', self.performanceContext);
					if(err){
						log.warn("failed to return benchmark report filter options : "+err);
					}
					perfMetricSvc.startTiming('Page:Benchmarking:Build');
					
                    try{

	
						
						self.regionOptions =    _.sortBy(JSON.parse(_.get(results, '[0].regionOptions', '[]')),"DropDownSeq");
						self.herdSizeOptions =  _.sortBy(JSON.parse(_.get(results, '[0].herdSizeOptions', '[]')),"DropDownSeq");
						self.farmTypeOptions = _.sortBy(JSON.parse(_.get(results, '[0].farmTypeOptions', '[]')),"DropDownSeq");
						self.breedNameOptions = _.sortBy(JSON.parse(_.get(results, '[0].breedNameOptions', '[]')),"DropDownSeq");
						self.lactationOptions = _.sortBy(JSON.parse(_.get(results, '[0].lactationOptions', '[]')),"DropDownSeq");
						self.vwpRangeOptions = _.sortBy(JSON.parse(_.get(results, '[0].vwpRangeOptions', '[]')),"DropDownSeq");
						
		
						
						self.defaultRegion = _.find(self.regionOptions,function(option){ return _.isEqual(option.DropDownSeq, _.min(_.pluck(self.regionOptions,'DropDownSeq')) );});
						self.defaultHerdSize = _.find(self.herdSizeOptions,function(option){ return _.isEqual(option.DropDownSeq, _.min(_.pluck(self.herdSizeOptions,'DropDownSeq')) );});
						self.defaultFarmType = _.find(self.farmTypeOptions,function(option){ return _.isEqual(option.DropDownSeq, _.min(_.pluck(self.farmTypeOptions,'DropDownSeq')) );});
						self.defaultBreedName = _.find(self.breedNameOptions,function(option){ return _.isEqual(option.DropDownSeq, _.min(_.pluck(self.breedNameOptions,'DropDownSeq')) );});
						self.defaultLactation = _.find(self.lactationOptions,function(option){ return _.isEqual(option.DropDownSeq, _.min(_.pluck(self.lactationOptions,'DropDownSeq')) );});
						self.defaultVWPRange = _.find(self.vwpRangeOptions,function(option){ return _.isEqual(option.DropDownSeq, _.min(_.pluck(self.vwpRangeOptions,'DropDownSeq')) );});
						
						self.selectedRegion    = self.defaultRegion;
						self.selectedHerdSize  = self.defaultHerdSize;
						self.selectedFarmType = self.defaultFarmType;
						self.selectedBreedName = self.defaultBreedName;
						self.selectedLactation = self.defaultLactation;
						self.selectedVWPRange = self.defaultVWPRange;

						
					}catch(e){
						log.warn("failed to parse one or more benchmarking filter option json: "+_.get(e,"message",""));
					}
					
					filterOptionsPromise.resolve(true);

					
					
				});

				return filterOptionsPromise.promise;
				
			}

			$s.onLactationFilterChange = function onLactationFilterChange(){
				
				if(_.isEqual(_.get(self.selectedLactation,'Code',""),'ALL')){
					self.selectedVWPRange = self.defaultVWPRange;
				}

				updateTable()
			}


			  $s.loadReportData = function loadReportData() {
				self.showErrorMessage = false;
				
				var filters = {
					herdId: self.currentHerd.herdId,
					region: _.get(self.selectedRegion,'Code',""),
					herdSize: _.get(self.selectedHerdSize,'Code',""),
					farmType: _.get(self.selectedFarmType,'Code',""),
					breedName: _.get(self.selectedBreedName,'Code',""),
					lactation: _.get(self.selectedLactation,'Code',""),
					vwpRange: _.get(self.selectedVWPRange,'Code',"")
					
				}
				perfMetricSvc.startTiming('Page:BenchmarkingPageData:Request');
				benchmarkingService.getBenchmarkingReportData(filters, self.performanceContext,
					function gotData(error, results) {
						perfMetricSvc.endTiming("page",'Page:BenchmarkingPageData:Request', self.performanceContext);
						self.loading = false;

						if (error) {
							log.error(error);

							self.benchmarks			= null;
							self.dataDiff			= null;
							
							self.tableRows			= null;
							self.errorMessage		= error;
							self.showErrorMessage	= true;

							return error;
						}

						var currentActiveHerdAdditionalHerdData = MSF.getAdditionalHerdDataItem(_.get(self.currentHerd, 'herdId'));
						var metaLastEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
						var metaDateFormat = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.dateFormat',mySynchConstSvc.defaultShortDateFormat);
						var longDateFormat = MSF.getLongDateFormatFromMetaFormatString(metaDateFormat,"/");
						self.dataUpdatedDate	= moment(metaLastEventDateString).toDate();
						self.dataUpdatedDisplay = !_.isUndefined(metaLastEventDateString) ? moment(metaLastEventDateString).format(longDateFormat) : null; //self.dataUpdatedDate ? formattedDisplayDate(results.reportDate) : null;
						self.thisFarm			= results.thisFarm;
						self.benchmarks			= results.reportData;
						self.dataIsRecent		= dateIsWithinLast30Days(results.reportDate);

						self.totalCows = $s.getTotalCowsDisplay();

						if (self.thisFarm && self.benchmarks && self.dataIsRecent) {
							self.dataDiff	= calculateDiffs(self.benchmarks, self.thisFarm);
							self.tableRows	= tableDisplayDataRows(self.benchmarks, self.thisFarm, self.dataDiff);
						} else {
							self.thisFarm	= null;
							self.benchmarks = null;
							self.dataDiff	= null;
							self.tableRows	= null;
						}
					});
			}

			function update() {
				self.territoryManager = MSF.getActiveFarmTerritoryManager();
				updateTable();
			}

			function updateTable() {
				self.currentHerd = MSF.getActiveHerd();
				
				$s.loadReportData();
			}

			self.updateTable = updateTable;

			$s.$on("destroy", function onDestroy() {
				if (deregOnHerdChanged) {
					deregOnHerdChanged();
				}
				self.performanceContext = null;
			});

			MSF.ready(function onMsfReady() {
				self.performanceContext = perfContextSvc.createPerformanceContext(_.get(self.currentHerd, 'herdId',null));
				perfMetricSvc.startTiming('Page:Benchmarking:Render');
				self.codeFile = MSF.lists.codeFile; 
				$s.loadFilterOptions().then(function(){
					update();
					perfMetricSvc.endTiming("page",'Page:Benchmarking:Build', self.performanceContext);
					perfMetricSvc.markPageReady('Page:Benchmarking:Render', self.performanceContext);
				}); 
				

				deregOnHerdChanged = $s.$on('herd:changed', function herdChanged() {
					perfMetricSvc.startTiming('Page:BenchmarkingOnHerdChanged:Render');
					$s.loadFilterOptions().then(function(){
						self.performanceContext = perfContextSvc.createPerformanceContext(_.get(MSF.getActiveHerd(), 'herdId',null));
						update();
						perfMetricSvc.endTiming("page",'Page:BenchmarkingHerdChanged:Build', self.performanceContext);
						perfMetricSvc.markPageReady('Page:BenchmarkingOnHerdChanged:Render', self.performanceContext);
					});
				});
			});
		}
	]);
})();
